import { truncateString } from "@/utils";
import FilterItem from "./FilterItem.vue";
import CampaignFilterBody from "./bodies/CampaignFilterBody.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
export default {
  name: "CampaignFilter",
  components: {
    FilterItem,
    CampaignFilterBody
  },
  emits: ["apply", "cleared"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    campaigns: {
      type: Object,
      required: true
    },
    sellers: {
      type: Object,
      required: true
    },
    marketplaces: {
      type: Object,
      required: true
    }
  },
  computed: {
    getCampaignTitle() {
      let joinedContents = this.campaigns.selected.map(el => el?.name).join(", ");
      joinedContents = joinedContents.length > 0 ? joinedContents : 'Campaigns';
      return truncateString(joinedContents, 16);
    },
    getCampaignSelectedTitle() {
      const joined = this.campaigns.selected.map(el => el?.name).join(", ");
      return joined.length > 0 ? truncateString(joined, 200) : "";
    }
  },
  methods: {
    handleCampaignSearch({
      value
    }) {
      // If value is empty, clear the searching state
      if (value.length === 0) {
        this.campaigns.searching = false;
      }
      this.campaigns.asyncSearch({
        keyword: value,
        args: {
          sellers: this.sellers.filterValues,
          sales_channel: this.marketplaces.filterValues
        }
      });
    },
    handleClear() {
      this.campaigns.clear();
      this.$emit('cleared');
    },
    onRestoreSearch() {
      this.campaigns.restoreSearch();
    },
    handleSelect({
      id
    }) {
      this.campaigns.select({
        id
      }, 'id');
    },
    handleSelectOnly({
      id
    }) {
      this.campaigns.selectOnly({
        id
      }, 'id');
    },
    handleDeselect({
      id
    }) {
      this.campaigns.deselect({
        id
      }, 'id');
      if (this.campaigns?.filterState?.selected.length === 0) {
        this.$emit('cleared');
      }
    },
    handleClearAll() {
      this.campaigns.clear();
      this.$emit('cleared');
    },
    onDiscard() {
      // Revert the staged pending changes back to the last-applied selection.
      this.campaigns.clearDraft();
    },
    onHidden() {
      this.campaigns.clearDraft();
    },
    onApply() {
      this.$emit('apply');
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs.campaignFilterItem, initializer, callback);
    }
  }
};